<template>
  <div>
    <canvas ref="canvas" :width="width" :height="height" :id="chartId"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.plugins.register(ChartDataLabels)

export default {
  name: 'MyBarChart',
  props: {
    chartId: {
      type: String,
      default: 'bar-chart'
    },
    width: {
      type: Number,
      default: 600
    },
    height: {
      type: Number,
      default: 400
    },
    chartData: {
      type: Object,
      required: true
    },
    chartOptions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chartInstance: null
    }
  },
  mounted() {
    const ctx = this.$refs.canvas.getContext('2d')

    const gradientBarPlugin = {
      afterDatasetsDraw: chart => {
        const meta = chart.getDatasetMeta(0)
        const ctx = chart.ctx

        meta.data.forEach((bar, index) => {
          const model = bar._model
          const gradient = ctx.createLinearGradient(
            model.x - model.width / 2, 0,
            model.x + model.width / 2, 0
          )
          gradient.addColorStop(0, '#4fd1c5') // Hijau
          gradient.addColorStop(1, '#4299e1') // Biru

          ctx.save()
          ctx.fillStyle = gradient
          ctx.fillRect(
            model.x - model.width / 2,
            model.y,
            model.width,
            model.base - model.y
          )
          ctx.restore()
        })
      }
    }

    this.chartInstance = new Chart(ctx, {
      type: 'bar',
      data: {
        ...this.chartData,
        datasets: this.chartData.datasets.map(ds => ({
          ...ds,
          backgroundColor: 'rgba(0,0,0,0)' // penting! biar gak tertimpa
        }))
      },
      options: {
        ...this.chartOptions,
        animation: { duration: 0 }
      },
      plugins: [ChartDataLabels, gradientBarPlugin]
    })
  },
  beforeDestroy() {
    if (this.chartInstance) this.chartInstance.destroy()
  }
}
</script>
